import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Row,
  Container,
} from 'reactstrap'
import styled from 'styled-components'
import { generateButton } from '../helpers/button'
import { FONTS, COLORS } from '../../../constants'

export const CancelTimesheetForm = (props) => {
  const { open, handleRemark } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => props.toggle() }
      >
        <HeaderForm toggle={ () => props.toggle() }>
          <HeadLabel>Reject Timesheet by HR</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Container>
            <Row>
              <TextLabel >Remarks (Optional)</TextLabel>
              <TextArea
                name="remark"
                onBlur={ (e) => handleRemark(e) }
              />
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          { generateButton('cancel', (type) => props.clickCancelButton(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

CancelTimesheetForm.propTypes = {
  clickCancelButton: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
  handleRemark: PropTypes.func,
}
CancelTimesheetForm.defaultProps = {
  clickCancelButton: () => {},
  toggle: () => {},
  open: false,
  handleRemark: () => {},
}

const HeaderForm = styled(ModalHeader)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
`
const HeadLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size:${FONTS.SMALL_SIZE};
`
const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid grey;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/cancel-timesheet.js